module.exports = __webpack_public_path__ + "img/01_abe_01.31ba6bd1.jpg";